<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="row">
      <div id="pageHeader" class="col-lg-7 col-12" [ngClass]="currentRequest && currentRequest.priority ? 'hasPriority' : ''">
        <div class="content-header row" *ngIf="contentHeader">
          <div class="content-header-left col-12 mb-2">
            <div class="row breadcrumbs-top">
              <div class="col-12">
                <h2 class="content-header-title mb-0">
                  {{ contentHeader.headerTitle | translate }}
                  <span class="rounded-circle ml-1" *ngIf="currentRequest.priority" [ngbTooltip]="'REQUEST_WITH_HIGH_PRIORITY' | translate"></span>
                </h2>
                <app-breadcrumb *ngIf="contentHeader.breadcrumb.links.length > 0" [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5" [ngClass.xl]="'text-right'" [ngClass.sm]="'col-12 text-center mb-2'" [ngClass.md]="'col-12 text-center mb-2'">
        <button type="button" class="btn btn-outline-primary mb-1" (click)="deleteRequest()" has_capability="delete_customer_request" *ngIf="!currentRequest.closed">
          {{ "DELETE" | translate }}
        </button>
        <button type="button" class="btn btn-outline-primary ml-1 mb-1" (click)="openModal(close_motivation_modal, null, 'close_request_btn')" [ngClass.md]="'mr-1'" has_capability="close_customer_request" *ngIf="!currentRequest.closed">
          {{ "CLOSE_REQUEST" | translate }}
        </button>
        <button type="button" class="btn btn-outline-primary ml-1 mb-1" (click)="reOpenRequest()" has_capability="close_customer_request" *ngIf="currentRequest.closed">
          {{ "REOPEN_REQUEST" | translate }}
        </button>
        <button type="button" class="btn btn-primary mb-1" [ngClass.xl]="'mx-1'" [routerLink]="'/dashboard/edit-request/' + idRequest" has_capability="edit_customer_request" *ngIf="!currentRequest.closed">
          {{ "EDIT" | translate }}
        </button>
      </div>
    </div>
    <div class="card" *ngIf="currentRequest.closed">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <h3 class="font-weight-bold">{{ "CLOSED_REQUEST" | translate }}</h3>
            <div class="font-weight-bold">{{ "MOTIVATION" | translate }}:</div>
            <span>{{ currentRequest.closed_motivation }}</span>
          </div>
        </div>
      </div>
    </div>

    <section *ngIf="currentRequest" id="page-accordion">
      <div class="row">
        <div class="col-md-4 col-12">
          <!-- richiesta -->
          <div class="card" [ngClass]="activeTab === 'request' ? 'active' : ''">
            <div class="card-title px-2 mb-0" (click)="changeTab('request')">
              <h4>{{ "REQUEST" | translate }}</h4>
            </div>
            <section [ngClass]="activeTab === 'request' ? 'card-body' : ''">
              <div class="d-flex justify-content-between">
                <div>
                  <label class="font-small-4 font-weight-bold">{{ "CUSTOMER" | translate }}:</label>
                  <p class="font-medium-1">{{ currentRequest.client }}</p>
                </div>
                <div>
                  <label class="font-small-4 font-weight-bold">{{ "INSERT_DATE" | translate }}:</label>
                  <span class="font-small-4"> {{ currentRequest.date | date: "dd/MM/yyyy" }}</span>
                </div>
              </div>
              <div class="mb-1">
                <label class="font-small-4 font-weight-bold">{{ "CUSTOMER_REFERENCE" | translate }}:</label>
                <div class="d-flex justify-content-between font-medium-1">
                  <div>{{ currentRequest.referent?.firstname }} {{ currentRequest.referent?.lastname }}</div>
                  <div *ngIf="currentRequest.referent?.email">
                    <a href="mailto:{{currentRequest.referent?.email}}" [ngbTooltip]="'SEND_EMAIL' | translate">{{currentRequest.referent?.email}}</a>
                  </div>
                  <div *ngIf="currentRequest.referent?.phone">
                    <a href="tel:{{currentRequest.referent?.phone}}" [ngbTooltip]="'CALL' | translate">{{currentRequest.referent?.phone}}</a>
                  </div>
                </div>
              </div>
              <div>
                <label class="font-small-4 font-weight-bold">{{ "RATE" | translate }}:</label>
                <p class="font-medium-1">{{ currentRequest && currentRequest.rate ? _utilService.addDotsToNumber(currentRequest.rate) : this._utilService.addDotsToNumber(0) }} €</p>
              </div>
              <div *ngIf="currentRequest.commercial">
                <label class="font-small-4 d-block font-weight-bold">{{ "CUSTOMER_COMMERCIAL" | translate }}:</label>
                <a routerLink="/dashboard/user/profile/{{ currentRequest.commercial.hash }}" class="font-medium-1 mb-0">{{ currentRequest.commercial.complete_name }}</a>
              </div>
            </section>
          </div>
        </div>

        <div class="col-md-8 col-12">
          <!-- dettagli -->
          <div class="card" [ngClass]="activeTab === 'details' ? 'active' : ''">
            <div class="card-title px-2 mb-0" (click)="changeTab('details')">
              <h4>{{ "DETAILS" | translate }}</h4>
            </div>
            <section [ngClass]="activeTab === 'details' ? 'card-body' : ''">
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold">{{ "FIGURE" | translate }}:</label>
                <p class="font-medium-1 d-inline">{{ currentRequest.figure }}{{ currentRequest.figure2 ? ", " + currentRequest.figure2 : null }}</p>
              </div>
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold">{{ "CITY" | translate }}:</label>
                <p class="font-medium-1 d-inline">{{ currentRequest.city }}</p>
              </div>
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold">{{ "JOB_SITE" | translate }}:</label>
                <p class="font-medium-1 d-inline">{{ currentRequest.site }}</p>
              </div>
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold">{{ "EDUCATION_TITLE" | translate }}:</label>
                <p class="font-medium-1 d-inline" *ngIf="currentRequest.education_title_name">{{ currentRequest.education_title_name }}</p>
              </div>
              <div class="font-medium-1 mb-075" *ngIf="!currentRequest.education_title_name">
                {{ "FIELD_NOT_SPECIFIED" | translate }}
              </div>
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold">{{ "REQUIRED_SKILLS" | translate }}:</label>
                <div class="d-inline">
                  <span
                    class="badge badge-pill mb-1 mr-025"
                    *ngFor="let skill of currentRequest.required_skills"
                    placement="top"
                    [ngbTooltip]="_utilService.ucFirst(skill.level)"
                    [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
                  >{{ skill.name }}</span
                  >
                </div>
                <div class="font-medium-1 mb-075 d-inline" *ngIf="currentRequest.required_skills && currentRequest.required_skills.length < 1">
                  {{ "NO_ONE" | translate }}
                </div>
              </div>
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold">{{ "OPTIONAL_SKILLS" | translate }}:</label>
                <div class="d-inline">
                  <span
                    class="badge badge-pill mr-025"
                    *ngFor="let skill of currentRequest.optional_skills"
                    [ngbTooltip]="_utilService.ucFirst(skill.level)"
                    placement="top"
                    [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
                  >{{ skill.name }}</span
                  >
                </div>
                <div class="font-medium-1 mb-075 d-inline" *ngIf="currentRequest.optional_skills && currentRequest.optional_skills.length < 1">{{ "NO_ONE" | translate }}</div>
              </div>
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold" [ngClass.sm]="'mt-1'">{{ "CERTIFICATIONS" | translate }}:</label>
                <div class="d-inline">
                  <span class="badge badge-pill badge-light-primary mr-025" *ngFor="let certification of currentRequest.certifications">
                    {{ certification.name }}
                  </span>
                </div>
                <div class="font-medium-1 mb-075 d-inline" *ngIf="!currentRequest.certifications">
                  {{ "NO_ONE" | translate }}
                </div>
              </div>
              <div>
                <label class="font-small-4 mr-1 mb-075 font-weight-bold" [ngClass.sm]="'mt-1'">{{ "REQUIRED_LANGUAGES" | translate }}:</label>
                <div class="d-inline">
                  <span class="badge badge-pill badge-light-dark mr-025" *ngFor="let language of currentRequest.languages">{{ language }}</span>
                </div>
                <div class="font-medium-1 d-inline" *ngIf="currentRequest.languages && currentRequest.languages.length < 1">{{ "NO_ONE" | translate }}</div>
              </div>
            </section>
          </div>
        </div>

        <div class="col-12">
          <!--                    descrizione-->
          <div class="card" [ngClass]="activeTab === 'description' ? 'active' : ''">
            <div class="card-title px-2 mb-0" (click)="changeTab('description')">
              <h4>{{ "DESCRIPTION" | translate }}</h4>
            </div>
            <section [ngClass]="activeTab === 'description' ? 'card-body' : ''">
              <div [innerHTML]="currentRequest.description" class="font-medium-1"></div>
            </section>
          </div>
        </div>

        <!--desktop-->
        <div class="col-12" *ngIf="_utilService.isDesktop">
          <div class="card pt-0">
            <div class="card-body p-0">
              <!--4 pulsanti-->
              <div class="row my-2 justify-content-center">
                <!--Bottoni Candidati-->
                <button *ngIf="!currentRequest.closed" class="btn btn-{{ showTab === 'candidate' ? 'outline-success' : 'success' }} mx-1" (click)="showTab = 'candidate'; singleTimeLineCandidate = []">
                  {{ "TITLES.USERS_TYPES.candidate" | translate }}
                  <span *ngIf="showSpinnerCandidate">
                    <span [data-feather]="'loader'" [class]="'spinner'" size="15"></span>
                  </span>
                  <span *ngIf="!showSpinnerCandidate">{{ suitablesCandidates.length }}</span>
                </button>
                <!--/ Bottoni Candidati-->
                <!--Bottoni Employee-->
                <button *ngIf="!currentRequest.closed" class="btn btn-{{ showTab === 'employee' ? 'outline-primary' : 'primary' }} mx-1" (click)="showTab = 'employee'; singleTimeLineCandidate = []">
                  {{ "TITLES.USERS_TYPES.employee" | translate }}
                  <span *ngIf="showSpinnerEmployee">
                    <span [data-feather]="'loader'" [class]="'spinner'" size="15"></span>
                  </span>
                  <span *ngIf="!showSpinnerEmployee">{{ suitablesEmployees.length }}</span>
                </button>
                <!--/ Bottoni Employee-->
                <!--Bottoni Ex Employee-->
                <button *ngIf="!currentRequest.closed" class="btn btn-{{ showTab === 'ex_employees' ? 'outline-info' : 'info' }} mx-1" (click)="showTab = 'ex_employees'; singleTimeLineCandidate = []">
                  {{ "TITLES.USERS_TYPES.ex-employee" | translate }}
                  <span *ngIf="showSpinnerExEmployee" class="ml-025">
                    <span [data-feather]="'loader'" [class]="'spinner'" size="15"></span>
                  </span>
                  <span *ngIf="!showSpinnerExEmployee">{{ suitablesExEmployees.length }}</span>
                </button>
                <!--/ Bottoni Ex Employee-->
                <!--Bottone Idonei-->
                <button class="btn btn-{{ showTab === 'proposed' ? 'outline-secondary' : 'secondary' }} mx-1" [disabled]="allStepList && allStepList.length < 1" (click)="showTab = 'proposed'">
                  {{ "TITLES.USERS_TYPES.suitables" | translate }} {{ allStepList.length }}
                </button>
              </div>
              <!-- cerca -->
              <div class="d-flex p-2 justify-content-between border-top" *ngIf="showTab === 'candidate' || showTab === 'employee' || showTab === undefined">
                <div class="col-2">
                  <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="getItems()" />
                </div>
                <!-- mostra -->
                <div class="col-md-2">
                  <label class="d-flex align-items-center"
                  >{{ "SHOW" | translate }}
                    <select class="form-control ml-075 pr-3" (change)="tableLimit = $any($event.target).value">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label>
                </div>
              </div>

              <!-- Candidates List-->
              <div *ngIf="showTab === 'candidate' || showTab === 'employee' || showTab === 'ex_employees'">
                <div id="loading_data" class="text-center" *ngIf="!tabs_loaded_data.includes(showTab)">
                  <div>
                    <span [data-feather]="'loader'" [class]="'spinner'" size="30"></span>
                    <h4 class="mb-0 mt-1">{{ "LOADING_DATA" | translate }}</h4>
                  </div>
                </div>
                <ngx-datatable
                  class="bootstrap core-bootstrap px-0"
                  columnMode="force"
                  *ngIf="tabs_loaded_data.includes(showTab)"
                  [headerHeight]="config.headerHeight"
                  [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
                  [scrollbarH]="config.scrollbarH"
                  [rowHeight]="config.rowHeight"
                  [limit]="tableLimit"
                  [footerHeight]="config.footerHeight"
                  [rows]="getItems()"
                >
                  <ngx-datatable-column
                    name="{{ 'FIRSTNAME' | translate }}"
                    prop="complete_name"
                    [width]="windowWidth > 1440 ? 170 : 130"
                    [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)"
                  >
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.complete_name }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'LAST_UPDATE' | translate" prop="update_date" sortable="true" *ngIf="showTab==='candidate'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.update_date | date: 'dd/MM/yyyy' }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="{{ 'CITY' | translate }}" prop="working_city" sortable="true" [width]="100"
                                        [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span class="text-break-line-1" [ngbTooltip]="row.working_city" placement="left">{{ row.working_city }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="{{ 'MENU.JOB_SITE' | translate }}" prop="site" [width]="100"
                                        [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row?.desired_site ? row?.desired_site : row.site }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'COST' | translate" prop="cost_total_daily" [width]="windowWidth > 1440 ? 100 : 90" has_capability="candidate_view_costs"
                                        [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.cost_total_daily }} €</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'SKILL' | translate" prop="status" [width]="windowWidth > 1440 ? 100 : 90"
                                        [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span class="badge text-break-line-1" [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
                            *ngFor="let skill of filterPrimarySkillCandidate(row.skills)" [ngbTooltip]="skill.name + ' - ' + _utilService.ucFirst(skill.level)">{{ skill.name }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'AFFINITY' | translate" prop="points" width="150"
                                        [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="progress position-relative">
                        <div class="progress-percentage-colored">{{ row.points }}%</div>
                        <div class="progress-percentage-white" [style]="'clip-path: polygon(0 0, ' + row.points + '% 0%, ' + row.points + '% 100%, 0% 100%);'">{{ row.points }}%</div>
                        <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" [style]="'width: ' + row.points + '%'"></div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex align-items-center">
                        <button class="btn btn-outline-secondary btn-sm" (click)="openModal(userModal, row, null)">{{ "VIEW" | translate }}</button>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>
              <!-- / Candidates List -->

              <!-- Tab proposed -->
              <div class="row justify-content-center mt-2" *ngIf="showTab === 'proposed'">
                <div class="col-12 d-flex justify-content-center" cdkDropListGroup>
                  <div class="container-suitable-candidate">
                    <h4 class="text-center">{{ "REQUEST_STEPS.SUITABLE" | translate }}</h4>
                    <div cdkDropList [cdkDropListData]="step0" class="list-container" id="step0" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                      <div
                        class="cursor-move badge badge-secondary mt-075 {{ cannotDragCandidate(item) ? 'opacity-50' : '' }}"
                        (dblclick)="navigateToProfile(item)"
                        *ngFor="let item of step0"
                        (cdkDragStarted)="selectedSuitableCandidate = item"
                        [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                        (click)="getTimeLineCandidates(item.user_hash)"
                        cdkDrag
                      >
                        <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="container-suitable-candidate">
                    <h4 class="text-center">{{ "REQUEST_STEPS.PROPOSED" | translate }}</h4>
                    <div cdkDropList [cdkDropListData]="step1" class="list-container" id="step1" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                      <div
                        class="cursor-move badge badge-warning mt-075 {{ cannotDragCandidate(item) ? 'opacity-50' : '' }}"
                        *ngFor="let item of step1"
                        (cdkDragStarted)="selectedSuitableCandidate = item"
                        [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                        (click)="getTimeLineCandidates(item.user_hash)"
                        cdkDrag
                      >
                        <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="container-suitable-candidate">
                    <h4 class="text-center">{{ "REQUEST_STEPS.FIRST_CALL" | translate }}</h4>
                    <div cdkDropList [cdkDropListData]="step2" class="list-container" id="step2" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                      <div
                        class="cursor-move badge badge-info mt-075 {{ cannotDragCandidate(item) ? 'opacity-50' : '' }}"
                        *ngFor="let item of step2"
                        (cdkDragStarted)="selectedSuitableCandidate = item"
                        [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                        (click)="getTimeLineCandidates(item.user_hash)"
                        (dblclick)="openEditCall(item)"
                        cdkDrag
                      >
                        <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="container-suitable-candidate">
                    <h4 class="text-center">{{ "REQUEST_STEPS.SECOND_CALL" | translate }}</h4>
                    <div cdkDropList [cdkDropListData]="step3" class="list-container" id="step3" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                      <div
                        class="cursor-move badge badge-info mt-075 {{ cannotDragCandidate(item) ? 'opacity-50' : '' }}"
                        *ngFor="let item of step3"
                        (cdkDragStarted)="selectedSuitableCandidate = item"
                        [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                        (click)="getTimeLineCandidates(item.user_hash)"
                        (dblclick)="openEditCall(item)"
                        cdkDrag
                      >
                        <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="container-suitable-candidate">
                    <h4 class="text-center">{{ "REQUEST_STEPS.KO" | translate | uppercase }}</h4>
                    <div cdkDropList [cdkDropListData]="step4" class="list-container" id="step4" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                      <div
                        class="cursor-move badge badge-danger mt-075 {{ cannotDragCandidate(item) ? 'opacity-50' : '' }}"
                        *ngFor="let item of step4"
                        (cdkDragStarted)="selectedSuitableCandidate = item"
                        [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                        (click)="getTimeLineCandidates(item.user_hash)"
                        cdkDrag
                      >
                        <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="container-suitable-candidate">
                    <h4 class="text-center">{{ "REQUEST_STEPS.OK" | translate | uppercase }}</h4>
                    <div cdkDropList [cdkDropListData]="step5" class="list-container" id="step5" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                      <div
                        class="cursor-move badge badge-success mt-075 {{ cannotDragCandidate(item) ? 'opacity-50' : '' }}"
                        *ngFor="let item of step5"
                        (cdkDragStarted)="selectedSuitableCandidate = item"
                        [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                        (click)="getTimeLineCandidates(item.user_hash)"
                        cdkDrag
                      >
                        <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="container-suitable-candidate">
                    <h4 class="text-center">{{ "REQUEST_STEPS.BARGAINING" | translate }}</h4>
                    <div cdkDropList [cdkDropListData]="step6" class="list-container" id="step6" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                      <div
                        class="cursor-move badge badge-primary mt-075 {{ cannotDragCandidate(item) ? 'opacity-50' : '' }}"
                        (dblclick)="item.user.user_type === 'candidate' && !currentRequest.closed ? selectBargainingOrCollaborator(item.user_hash) : null"
                        *ngFor="let item of step6"
                        (cdkDragStarted)="selectedSuitableCandidate = item"
                        [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                        (click)="getTimeLineCandidates(item.user_hash)"
                        cdkDrag
                      >
                        <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Tab proposed -->

              <!--TimeLine-->
              <div class="col-12 mt-4" *ngIf="singleTimeLineCandidate && singleTimeLineCandidate.length > 1">
                <h3>
                  <a
                    target="_blank"
                    [routerLink]="
                      singleTimeLineCandidate[0].user.user_type === 'candidate' ? '/dashboard/candidate/edit/' + singleTimeLineCandidate[0].user.hash : '/dashboard/user/profile/' + singleTimeLineCandidate[0].user.hash
                    "
                  >{{ singleTimeLineCandidate[0].user.complete_name }}</a
                  >
                </h3>
                <ul class="timeline my-2">
                  <li class="timeline-item" *ngFor="let step of singleTimeLineCandidate">
                    <span class="timeline-point timeline-point-{{ step.color_step }} timeline-point-indicator"></span>
                    <div class="timeline-event">
                      <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                        <div class="col-md-6 col-12">
                          <h6 *ngIf="step.step == 2 || step.step == 3; else h6Normal">
                            {{ step.label_step }} {{ step.date ? ("IN_DATE" | translate) + " " + _utilService.formatDate(step.date, "DD/MM/YYYY HH:mm") : null }}
                          </h6>
                          <ng-template #h6Normal>
                            <h6>{{ step.label_step }}</h6>
                          </ng-template>
                          <p *ngIf="step.note">{{ step.note }}</p>
                        </div>
                        <div class="col-md-6 col-12 text-right">
                          <div class="timeline-event-time mb-05">{{ "INSERTED_BY" | translate }} {{ step.creator.complete_name }}</div>
                          <div class="timeline-event-time">{{ "THE_MASCULIN" | translate }} {{ _utilService.formatDate(step.insert_date, "DD/MM/YYYY") }}</div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <!--/ TimeLine-->
            </div>
          </div>
        </div>

        <!--mobile - tablet-->
        <div class="col-12" *ngIf="_utilService.isMobile || _utilService.isTablet">
          <div ngbDropdown>
            <button type="button" class="btn btn-outline-primary mb-1 w-100" ngbDropdownToggle>
              {{ "TITLES.USERS_TYPES." + (showTab == "proposed" ? "suitables" : showTab) | translate }}
              {{
                showTab === "candidate"
                  ? this.suitablesCandidates?.length
                  : showTab === "employee"
                    ? this.suitablesEmployees?.length
                    : showTab === "ex_employees"
                      ? this.suitablesExEmployees?.length
                      : showTab === "proposed"
                        ? this.allStepList.length
                        : ""
              }}
            </button>
            <div ngbDropdownMenu class="w-100">
              <div [ngClass]="activeTab === 'users' ? 'row my-2 justify-content-center' : ''">
                <ul class="nav nav-pills flex-column">
                  <li class="nav-item" ngbDropdownItem>
                    <button
                      class="btn btn-{{ showTab === 'candidate' ? 'outline-success' : 'success' }} w-100"
                      [disabled]="this.suitablesCandidates && this.suitablesCandidates < 1"
                      (click)="showTab = 'candidate'; singleTimeLineCandidate = []"
                    >
                      {{ "TITLES.USERS_TYPES.candidate" | translate }} <span *ngIf="showSpinnerCandidate"> <span [data-feather]="'loader'" [class]="'spinner'" size="15"></span></span>
                      {{ !showSpinnerCandidate ? this.suitablesCandidates.length : null }}
                    </button>
                  </li>
                  <li ngbDropdownItem>
                    <button
                      class="btn btn-{{ showTab === 'employee' ? 'outline-primary' : 'primary' }} w-100"
                      [disabled]="this.suitablesEmployees && this.suitablesEmployees.length < 1"
                      (click)="showTab = 'employee'; singleTimeLineCandidate = []"
                    >
                      {{ "TITLES.USERS_TYPES.employee" | translate }} <span *ngIf="showSpinnerEmployee"> <span [data-feather]="'loader'" [class]="'spinner'" size="15"></span></span>
                      {{ !showSpinnerEmployee ? this.suitablesEmployees.length : null }}
                    </button>
                  </li>
                  <li ngbDropdownItem>
                    <button
                      class="btn btn-{{ showTab === 'ex_employees' ? 'outline-info' : 'info' }} w-100"
                      [disabled]="this.suitablesExEmployees && this.suitablesExEmployees.length < 1"
                      (click)="showTab = 'ex_employees'; singleTimeLineCandidate = []"
                    >
                      {{ "TITLES.USERS_TYPES.ex-employee" | translate }} <span *ngIf="showSpinnerExEmployee"> <span [data-feather]="'loader'" [class]="'spinner'" size="15"></span></span>
                      {{ !showSpinnerExEmployee ? this.suitablesExEmployees.length : null }}
                    </button>
                  </li>
                  <li ngbDropdownItem>
                    <button class="btn btn-{{ showTab === 'proposed' ? 'outline-secondary' : 'secondary' }} w-100" [disabled]="allStepList && allStepList.length < 1" (click)="showTab = 'proposed'">
                      {{ "TITLES.USERS_TYPES.suitables" | translate }} {{ allStepList.length }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <!--candidati, dipendenti, ex dipendenti-->
            <div class="my-card p-0 m-0">
              <div class="card-body p-0 m-0">
                <ngx-datatable
                  *ngIf="showTab === 'candidate' || showTab === 'employee' || showTab === 'ex_employees' || showTab === undefined"
                  class="bootstrap core-bootstrap my-height mb-2"
                  columnMode="force"
                  [headerHeight]="config.headerHeight"
                  [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
                  [scrollbarH]="config.scrollbarH"
                  [scrollbarV]="true"
                  [rowHeight]="60"
                  [rows]="getItems()"
                >
                  <ngx-datatable-column [name]="'FIRSTNAME' | translate" prop="complete_name" width="200" [sortable]="true">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.complete_name }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'LAST_UPDATE' | translate" prop="update_date" sortable="true" *ngIf="showTab==='candidate'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.update_date | date: 'dd/MM/yyyy' }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'CITY' | translate" prop="working_city" sortable="true">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.working_city }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'JOB_SITE' | translate" prop="site" [sortable]="true">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row?.desired_site ? row?.desired_site : row.site }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'COST' | translate" prop="cost_total_daily" sortable="true" has_capability="candidate_view_costs">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.cost_total_daily }} €</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'SKILL' | translate" prop="status" [sortable]="true">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span class="badge" [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'" *ngFor="let skill of filterPrimarySkillCandidate(row.skills)"
                            [ngbTooltip]="skill.level">{{ skill.name }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'AFFINITY' | translate" prop="points" [sortable]="(showTab === 'candidate' && !showSpinnerCandidate) || (showTab === 'employee' && !showSpinnerEmployee) || (showTab === 'ex-employee' && !showSpinnerExEmployee)">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="progress position-relative">
                        <div class="progress-percentage-colored">{{ row.points }}%</div>
                        <div class="progress-percentage-white" [style]="'clip-path: polygon(0 0, ' + row.points + '% 0%, ' + row.points + '% 100%, 0% 100%);'">{{ row.points }} %</div>
                        <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" [style]="'width: ' + row.points + '%'"></div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex align-items-center">
                        <button class="btn btn-outline-secondary btn-sm" (click)="openModal(userModal, row, null)">{{ "VIEW" | translate }}</button>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>
            </div>
            <!--idonei-->
            <div class="row justify-content-center mb-2" *ngIf="showTab === 'proposed'">
              <div class="col-12 d-flex flex-column" cdkDropListGroup>
                <!--stati del candidato-->
                <div class="container-suitable-candidate">
                  <h4 class="text-center">{{ "REQUEST_STEPS.SUITABLE" | translate }}</h4>
                  <div cdkDropList [cdkDropListData]="step0" class="list-container" id="mobilStep0" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                    <div
                      class="cursor-move badge badge-secondary mt-075"
                      *ngFor="let item of step0"
                      (cdkDragStarted)="selectedSuitableCandidate = item"
                      [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                      (click)="getTimeLineCandidates(item.user_hash)"
                      cdkDrag
                    >
                      <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                    </div>
                  </div>
                </div>

                <div class="container-suitable-candidate">
                  <h4 class="text-center">{{ "REQUEST_STEPS.PROPOSED" | translate }}</h4>
                  <div cdkDropList [cdkDropListData]="step1" class="list-container" id="mobilStep1" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                    <div
                      class="cursor-move badge badge-warning mt-075"
                      *ngFor="let item of step1"
                      (cdkDragStarted)="selectedSuitableCandidate = item"
                      [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                      (click)="getTimeLineCandidates(item.user_hash)"
                      cdkDrag
                    >
                      <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                    </div>
                  </div>
                </div>

                <div class="container-suitable-candidate">
                  <h4 class="text-center">{{ "REQUEST_STEPS.FIRST_CALL" | translate }}</h4>
                  <div cdkDropList [cdkDropListData]="step2" class="list-container" id="mobilStep2" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                    <div
                      class="cursor-move badge badge-info mt-075"
                      *ngFor="let item of step2"
                      (cdkDragStarted)="selectedSuitableCandidate = item"
                      [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                      (click)="getTimeLineCandidates(item.user_hash)"
                      cdkDrag
                    >
                      <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                    </div>
                  </div>
                </div>

                <div class="container-suitable-candidate">
                  <h4 class="text-center">{{ "REQUEST_STEPS.SECOND_CALL" | translate }}</h4>
                  <div cdkDropList [cdkDropListData]="step3" class="list-container" id="mobilStep3" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                    <div
                      class="cursor-move badge badge-info mt-075"
                      *ngFor="let item of step3"
                      (cdkDragStarted)="selectedSuitableCandidate = item"
                      [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                      (click)="getTimeLineCandidates(item.user_hash)"
                      cdkDrag
                    >
                      <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                    </div>
                  </div>
                </div>

                <div class="container-suitable-candidate">
                  <h4 class="text-center">{{ "REQUEST_STEPS.KO" | translate | uppercase }}</h4>
                  <div cdkDropList [cdkDropListData]="step4" class="list-container" id="mobilStep4" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                    <div
                      class="cursor-move badge badge-danger mt-075"
                      *ngFor="let item of step4"
                      (cdkDragStarted)="selectedSuitableCandidate = item"
                      [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                      (click)="getTimeLineCandidates(item.user_hash)"
                      cdkDrag
                    >
                      <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                    </div>
                  </div>
                </div>

                <div class="container-suitable-candidate">
                  <h4 class="text-center">{{ "REQUEST_STEPS.OK" | translate | uppercase }}</h4>
                  <div cdkDropList [cdkDropListData]="step5" class="list-container" id="mobilStep5" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                    <div
                      class="cursor-move badge badge-success mt-075"
                      *ngFor="let item of step5"
                      (cdkDragStarted)="selectedSuitableCandidate = item"
                      [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                      (click)="getTimeLineCandidates(item.user_hash)"
                      cdkDrag
                    >
                      <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                    </div>
                  </div>
                </div>

                <div class="container-suitable-candidate">
                  <h4 class="text-center">{{ "REQUEST_STEPS.BARGAINING" | translate }}</h4>
                  <div cdkDropList [cdkDropListData]="step6" class="list-container" id="mobilStep6" (cdkDropListDropped)="drop($event)" [style]="'min-height:' + setContainerHeight()">
                    <div
                      class="cursor-move badge badge-primary mt-075"
                      (dblclick)="item.user.user_type === 'candidate' && !currentRequest.closed ? selectBargainingOrCollaborator(item.user_hash) : null"
                      *ngFor="let item of step6"
                      (cdkDragStarted)="selectedSuitableCandidate = item"
                      [ngbTooltip]="'TITLES.USERS_TYPES_SINGULAR.' + item.user.user_type | translate"
                      (click)="getTimeLineCandidates(item.user_hash)"
                      cdkDrag
                    >
                      <span class="font-small-4 font-weight-normal">{{ item.user.complete_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--dettagli del candidato-->
            <div class="col-12 mt-4" *ngIf="singleTimeLineCandidate && singleTimeLineCandidate.length > 1">
              <h3>
                <a
                  target="_blank"
                  [routerLink]="
                    singleTimeLineCandidate[0].user.user_type === 'candidate' ? '/dashboard/candidate/edit/' + singleTimeLineCandidate[0].user.hash : '/dashboard/user/profile/' + singleTimeLineCandidate[0].user.hash
                  "
                >{{ singleTimeLineCandidate[0].user.complete_name }}</a
                >
              </h3>
              <ul class="timeline my-2">
                <li class="timeline-item" *ngFor="let step of singleTimeLineCandidate">
                  <span class="timeline-point timeline-point-{{ step.color_step }} timeline-point-indicator"></span>
                  <div class="timeline-event">
                    <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                      <div class="col-md-6 col-12">
                        <h6 *ngIf="step.step == 2 || step.step == 3; else h6Normal">
                          {{ step.label_step }} {{ step.date ? ("IN_DATE" | translate) + " " + _utilService.formatDate(step.date, "DD/MM/YYYY HH:mm") : null }}
                        </h6>
                        <ng-template #h6Normal>
                          <h6>{{ step.label_step }}</h6>
                        </ng-template>
                        <p *ngIf="step.note">{{ step.note }}</p>
                      </div>
                      <div class="col-md-6 col-12 text-right">
                        <div class="timeline-event-time mb-05">{{ "INSERTED_BY" | translate }} {{ step.creator.complete_name }}</div>
                        <div class="timeline-event-time">{{ "THE_MASCULIN" | translate }} {{ _utilService.formatDate(step.insert_date, "DD/MM/YYYY") }}</div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- User Modal -->
<ng-template #userModal let-modal>
  <div>
    <div class="modal-header">
      <div>
        <h3 class="mb-0">{{ "DETAIL_SINGULAR" | translate }} {{ showTab === "candidate" ? ("TITLES.USERS_TYPES_SINGULAR.candidate" | translate) : ("TITLES.USERS_TYPES_SINGULAR.employee" | translate) }}</h3>
      </div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body mb-1" tabindex="0">
      <div class="row" [ngClass.xl]="'mb-3'" [ngClass.sm]="'mb-1'">
        <div class="col-12" [ngClass.xl]="'mb-1'">
          <div class="d-flex justify-content-between">
            <h3 [ngClass.sm]="'mb-0'">{{ selectedUser.firstname }} {{ selectedUser.lastname }}</h3>
            <div class="text-right">
              <div class="font-small-4 font-weight-bold" [ngClass.xl]="'mr-025'" has_capability="candidate_view_costs">
                {{ "COST" | translate }} {{ showTab === "candidate" ? ("TITLES.USERS_TYPES_SINGULAR.candidate" | translate) : ("TITLES.USERS_TYPES_SINGULAR.employee" | translate) }}:
                <span class="font-medium-1">{{ selectedUser && selectedUser.cost_total_daily ? _utilService.addDotsToNumber(selectedUser.cost_total_daily) : _utilService.addDotsToNumber(0) }} €</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4 font-weight-bold">{{ "FIGURE" | translate }}:</label>
          <p class="font-medium-1">{{ selectedUser.figure }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4 font-weight-bold">{{ "CITY" | translate }}:</label>
          <p class="font-medium-1">{{ selectedUser.working_city }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4 font-weight-bold">{{ "DESIRED_CITY" | translate }}:</label>
          <p class="font-medium-1">{{ selectedUser.desired_city }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4 font-weight-bold">{{ "DESIRED_SITE" | translate }}:</label>
          <p class="font-medium-1">{{ selectedUser.desired_site }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4 font-weight-bold">{{ "EDUCATION_TITLE" | translate }}:</label>
          <p class="font-medium-1" *ngIf="selectedUser.education_title_name">{{ selectedUser.education_title_name }} {{ selectedUser.education_subject_name || selectedUser.education_subject }}</p>
          <div class="font-medium-1 mb-075" *ngIf="!selectedUser.education_title">
            {{ "FIELD_NOT_SPECIFIED" | translate }}
          </div>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4 font-weight-bold">{{ "LANGUAGES" | translate }}:</label>
          <div class="d-flex flex-wrap">
            <div *ngFor="let language of selectedUser.languages_complete" class="mr-1">
              <div
                *ngIf="selectedUser.languages_complete && selectedUser.languages_complete.length > 0"
                class="badge badge-pill badge-light-secondary mb-025"
                [ngClass.sm]="'mr-05'"
                [ngbTooltip]="('LEVEL_SPEAK' | translate) + ' ' + language.speak + ' | ' + ('LEVEL_WRITE' | translate) + ' ' + language.write"
              >
                {{ language.name }}
              </div>
            </div>
          </div>
          <div class="font-medium-1 mb-075" *ngIf="!selectedUser.languages_complete || (selectedUser.languages_complete && selectedUser.languages_complete.length < 1)">
            {{ "NO_ONE" | translate }}
          </div>
        </div>
        <div class="col-12" [ngClass.xl]="'mt-1'">
          <div class="d-flex">
            <label class="font-small-4 font-weight-bold mr-2">{{ "CERTIFICATIONS" | translate }}:</label>
            <div class="d-flex flex-wrap" *ngIf="selectedUser.certifications && selectedUser.certifications.length > 0">
              <div *ngFor="let certification of selectedUser.certifications" class="mr-1">
                <div class="badge badge-pill badge-light-primary mb-025" [ngClass.sm]="'mr-05'" [ngbTooltip]="certification.length > 30 ? certification : null">
                  {{ certification.length > 30 ? certification.slice(0, 30) + "..." : certification }}
                </div>
              </div>
            </div>
            <div class="font-medium-1 mb-075" *ngIf="!selectedUser.certifications || selectedUser.certifications.length < 1">
              {{ "NO_ONE" | translate }}
            </div>
          </div>
        </div>
        <div class="col-12" [ngClass.xl]="'mt-1'" *ngIf="selectedUser.skills">
          <div class="d-flex">
            <label class="font-small-4 font-weight-bold mr-2">{{ "SKILLS" | translate }}:</label>
            <div class="d-flex flex-wrap" *ngIf="selectedUser.skills.length > 0">
              <div *ngFor="let skill of selectedUser.skills">
                <div
                  class="badge badge-pill mr-05 mb-05"
                  [ngbTooltip]="_utilService.ucFirst(skill.level)"
                  [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
                >
                  {{ skill.name }}
                </div>
              </div>
            </div>
            <div class="font-medium-1" [ngClass.xl]="'mb-075'" *ngIf="selectedUser.skills.length < 1">
              {{ "NO_ONE" | translate }}
            </div>
          </div>
        </div>
      </div>
      <!--Dettaglio matchmaking parametri-->
      <div class="row parameter-title bg-light-secondary" [ngClass]="openParameter ? 'active' : ''" (click)="openParameter = !openParameter">
        <h3 class="col-12 mb-0">{{ "PARAMETER_MATCHMAKING_FOR" | translate }} {{ currentRequest.figure }}</h3>
      </div>
      <div class="parameter-section" [ngClass]="openParameter ? 'active' : ''">
        <div class="row bg-light-secondary pt-05">
          <div class="mt-05 mb-05" [ngClass.xl]="'col-4'" [ngClass.sm]="'col-7'">{{ "PARAMETER" | translate }}</div>
          <div class="mt-05 mb-05" [ngClass.xl]="'col-5'" [ngClass.sm]="'col-7'">{{ "REQUESTED_PARAMETERS" | translate }}</div>
          <div class="mt-05 mb-05" [ngClass.xl]="'col-3'" [ngClass.sm]="'col-5 pl-0'">{{ "AFFINITY" | translate }}</div>
        </div>
        <div *ngFor="let point of points" class="row mt-075 border-bottom border-bottom-secondary mb-075 pb-1">
          <div [ngClass.xl]="'col-4'" [ngClass.sm]="'col-7 pr-0'">
            <span>
              <span class="text-success" data-feather="check" *ngIf="selectedUser.matrix_points[point] > 0"></span>
              <span class="text-danger" data-feather="x" *ngIf="currentRequest[point] && (currentRequest[point].length > 0 || currentRequest[point] > 0) && selectedUser.matrix_points[point] === 0"></span>
              <span class="text-secondary" data-feather="minus" *ngIf="(!currentRequest[point] || currentRequest[point].length < 1) && selectedUser.matrix_points[point] === 0"></span>
              {{ point.toUpperCase() | translate }}
            </span>
          </div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center" *ngIf="point === 'city'">{{ currentRequest.city || ("FIELD_NOT_SPECIFIED" | translate) }}</div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center" *ngIf="point === 'figure'">{{ currentRequest.figure || ("FIELD_NOT_SPECIFIED" | translate) }}</div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center" *ngIf="point === 'site'">{{ currentRequest.site || ("FIELD_NOT_SPECIFIED" | translate) }}</div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center" *ngIf="point === 'rate'">{{ currentRequest.rate || ("FIELD_NOT_SPECIFIED" | translate) }} &euro;</div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center" *ngIf="point === 'education_title'">
            {{ currentRequest.education_title_name || ("FIELD_NOT_SPECIFIED" | translate) }}
          </div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center" *ngIf="point === 'certifications'">
            <div class="badge badge-pill mr-05 badge-light-dark" *ngFor="let cert of (currentRequest.certifications || []).slice(0, 3)">{{ cert.name }}</div>
            {{ !currentRequest.certifications || currentRequest.certifications.length < 1 ? ("FIELD_NOT_SPECIFIED" | translate) : "" }}
          </div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center" *ngIf="point === 'languages'">
            {{ currentRequest.languages && currentRequest.languages.length > 0 ? currentRequest.languages.join(", ") : ("FIELD_NOT_SPECIFIED" | translate) }}
          </div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0 flex-wrap'" class="d-flex align-items-center mb-075" *ngIf="point === 'required_skills'">
            <div
              class="badge badge-pill mr-05"
              [ngbTooltip]="_utilService.ucFirst(skill.level)"
              placement="top"
              *ngFor="let skill of (currentRequest.required_skills || []).slice(0, 3)"
              [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
            >
              {{ skill.name }}
            </div>
            <div *ngIf="!currentRequest.required_skills || currentRequest.required_skills.length < 1">{{ "FIELD_NOT_SPECIFIED" | translate }}</div>
          </div>
          <div [ngClass.xl]="'col-5'" [ngClass.sm]="'col-5 pl-0 flex-wrap'" class="d-flex align-items-center mb-075" *ngIf="point === 'optional_skills'">
            <div
              class="badge badge-pill mr-05"
              [ngbTooltip]="_utilService.ucFirst(skill.level)"
              placement="top"
              *ngFor="let skill of (currentRequest.optional_skills || []).slice(0, 3)"
              [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
            >
              {{ skill.name }}
            </div>
            <div *ngIf="!currentRequest.optional_skills || currentRequest.optional_skills.length < 1">{{ "FIELD_NOT_SPECIFIED" | translate }}</div>
          </div>
          <div [ngClass.xl]="'col-3'" [ngClass.sm]="'col-5 pl-0'" class="d-flex align-items-center">
            <div class="progress position-relative mt-025">
              <div class="progress-percentage-colored" *ngIf="selectedUser.matrix_points[point] < 100">
                {{ selectedUser.matrix_points[point] > 100 ? 100 : selectedUser.matrix_points[point] }}
                %
              </div>
              <div class="progress-percentage-white" [style]="'clip-path: polygon(0 0, ' + selectedUser.matrix_points[point] + '% 0%, ' + selectedUser.matrix_points[point] + '% 100%, 0% 100%);'">
                {{ selectedUser.matrix_points[point] > 100 ? 100 : selectedUser.matrix_points[point] }}%
              </div>
              <div
                class="progress-bar"
                [ngClass]="selectedUser.matrix_points[point] > 100 ? 'bg-success' : ''"
                role="progressbar"
                aria-valuemin="0"
                aria-valuemax="100"
                [style]="'width: ' + selectedUser.matrix_points[point] + '%'"
              ></div>
            </div>
            <span data-feather="arrow-up" size="19" class="text-success ml-025" *ngIf="selectedUser.matrix_points[point] > 100"></span>
          </div>
        </div>
        <div class="row mt-075">
          <div class="col-9">
            <span class="pl-2">{{ "TOTAL" | translate }}</span>
          </div>
          <div class="col-3">{{ selectedUser.points }}%</div>
        </div>
      </div>

      <!--Fine Dettaglio matchmaking parametri-->
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button (click)="modal.dismiss('Cross click')" class="btn btn-outline-primary w-150" rippleEffect>
        {{ "BACK" | translate }}
      </button>
      <a [href]="'/dashboard/candidate/edit/' + selectedUser.hash" class="btn btn-outline-primary w-150" *ngIf="selectedUser.user_type === 'candidate'" target="_blank">
        {{ "MENU.PROFILE" | translate }}
      </a>
      <a [href]="'/dashboard/user/profile/' + selectedUser.hash" class="btn btn-outline-primary w-150" *ngIf="selectedUser.user_type === 'employee'" target="_blank">
        {{ "MENU.PROFILE" | translate }}
      </a>
      <a [href]="'/dashboard/user/profile/' + selectedUser.hash" class="btn btn-outline-primary w-150" *ngIf="selectedUser.user_type === 'ex-employee'" target="_blank">
        {{ "MENU.PROFILE" | translate }}
      </a>
      <button has_capability="request_set_as_suitable" *ngIf="selectedUser && selectedUser.suitables != true && !currentRequest.closed" class="btn btn-primary w-150" rippleEffect (click)="setCandidateToSuitable(selectedUser.hash)">
        {{ "REQUEST_STEPS.SUITABLE" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / User Modal -->

<!-- Note Modal -->
<ng-template #noteModal let-modal>
  <div [formGroup]="formGroup">
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>
        {{ "ADD_NOTE" | translate }} {{ "STATE" | translate | lowercase }} :
        {{
          landingStep === "step1"
            ? ("REQUEST_STEPS.PROPOSED" | translate)
            : landingStep === "step4"
              ? ("REQUEST_STEPS.KO" | translate)
              : landingStep === "step5"
                ? ("REQUEST_STEPS.OK" | translate)
                : ("REQUEST_STEPS.BARGAINING" | translate)
        }}
      </h3>
      <div class="form-group mb-1" *ngIf="landingStep && landingStep.length > 0">
        <label for="note">{{ "NOTE" | translate }}<sup class="text-danger">*</sup></label>
        <textarea class="form-control {{ formGroup.controls?.note?.errors?.minlength ? 'is-invalid' : '' }}" name="note" id="note" cols="45" rows="3" formControlName="note"></textarea>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.note?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-outline-primary w-150" rippleEffect (click)="modalClose('back')">
      {{ "BACK" | translate }}
    </button>
    <button [disabled]="formGroup.controls?.note?.errors?.minlength" (click)="insertStep()" class="btn btn-primary w-150" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / note Modal -->

<!-- Note Date Modal -->
<ng-template #noteDateModal let-modal>
  <div [formGroup]="formGroup">
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ editStepNumber ? ("EDIT_INTERVIEW" | translate) : ("INSERT_INTERVIEW_NOTE" | translate) }}</h3>
      <div class="row">
        <div class="form-group col-md-6 mb-1">
          <label for="day">{{ "INSERT.DAY" | translate }}<sup class="text-danger">*</sup></label>
          <ng2-flatpickr id="day" [ngClass]="'day'" [config]="basicDateOptions" formControlName="day"></ng2-flatpickr>
        </div>
        <div class="form-group col-md-6 mb-1">
          <label for="time">{{ "HOUR_TO" | translate }}<sup class="text-danger">*</sup></label>
          <ngb-timepicker id="time" formControlName="time" [spinners]="false"></ngb-timepicker>
        </div>
        <div class="form-group col-12 mb-1">
          <label for="noteTwo">{{ "NOTE" | translate }}<sup class="text-danger">*</sup></label>
          <textarea formControlName="note" class="form-control {{ formGroup.controls?.note?.errors?.minlength ? 'is-invalid' : '' }}" name="noteAborted" id="noteTwo" cols="45" rows="3"></textarea>
          <div class="invalid-feedback" *ngIf="formGroup.controls?.note?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-outline-primary w-150" rippleEffect (click)="modalClose('back')">
      {{ "BACK" | translate }}
    </button>
    <button [disabled]="formGroup.value.note.length < 5" (click)="insertStep()" class="btn btn-primary w-150" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / note Date Modal -->

<!-- Close request Modal -->
<ng-template #close_motivation_modal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "CLOSE_REQUEST" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="motivation">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea class="form-control" maxlength="255" name="motivation" id="motivation" cols="45" rows="3" [(ngModel)]="close_motivation"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-outline-primary w-150" rippleEffect (click)="modalClose('close_motivation_modal')">
      {{ "BACK" | translate }}
    </button>
    <button [disabled]="!close_motivation || close_motivation.length < 5" (click)="closeRequest()" class="btn btn-primary w-150" rippleEffect>
      {{ "CLOSE_REQUEST" | translate }}
    </button>
  </div>
</ng-template>
<!-- / close request Modal -->
